import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UtilService } from '../../shared/util/util.service';
import {
  DateValueAccessor,
  CreateDateValueAccessorProvider,
  CreateDateValueValidationProvider,
} from '../../shared/widgets/value-accessors/date-value-accessor';
import {
  StringValueAccessor,
  CreateStringValueAccessorProvider,
  CreateStringValueValidationProvider,
} from '../../shared/widgets/value-accessors/string-value-accessor';
@Component({
  selector: 'wl-date-time-selector',
  templateUrl: 'date-time-selector.component.html',
  providers: [CreateDateValueAccessorProvider(DateTimeSelectorComponent), CreateDateValueValidationProvider(DateTimeSelectorComponent)],
    standalone: false
})
export class DateTimeSelectorComponent extends DateValueAccessor implements OnInit {
  @Input() required: any;

  @Output() onDateChanged = new EventEmitter<Date>();

  public _utilService: UtilService;

  public dateAsString: string;

  public constructor(utilService: UtilService) {
    super();
    this._utilService = utilService;
    this.value = new Date();
    this.setDateString(this.value);
  }

  writeValue(value: Date) {
    super.writeValue(value);
    this.setDateString(value);
  }

  public setDateString(dte: Date) {
    if (this._utilService.isNotNullOrUndefined(dte)) {
      if (dte instanceof Date) {
        let year = dte.getFullYear().toString();
        let month = (dte.getMonth() + 1).toString();
        let day = dte.getDate().toString();
        let hours = dte.getHours().toString();
        let minutes = dte.getMinutes().toString();

        if (hours.length < 2) hours = '0' + hours;

        if (minutes.length < 2) minutes = '0' + minutes;

        this.dateAsString = month + '/' + day + '/' + year + ' ' + hours + ':' + minutes;
      }
    }
  }

  public setDateValue(dte: string) {
    if (this._utilService.isNotNullEmptyOrWhitespace(dte)) {
      let ary = dte.trim().split(' ');

      let aryDatePart = ary[0].split('/');
      let year: number = Number(aryDatePart[2]);
      let month: number = Number(aryDatePart[0]) - 1;
      let day: number = Number(aryDatePart[1]);

      let aryTimePart = ary[1].split(':');
      let hours = Number(aryTimePart[0]);
      let minutes = Number(aryTimePart[1]);

      this.value = new Date(year, month, day, hours, minutes);
    }
  }

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {}
  modelChange() {}

  dateSelected(selectedValue: string) {
    //is a string
    this.setDateValue(selectedValue);
  }

  emitOutputObject = (): void => {};
}
